import { DropdownOption } from '@/common/getDropdownList';
import { Form } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { UseFormReturn } from 'react-hook-form';

export type AssignPointsFormValues = {
  userType: string;
  userName: string;
  currentCategory: string;
  pointCategoryId: string;
};

type AssignPointsFormViewProps = {
  form: UseFormReturn<AssignPointsFormValues>;
  userTypeOptions: DropdownOption[];
  userOptions: DropdownOption[];
  categoryOptions: DropdownOption[];
  currentCategoryLabel: string;
  onSubmit: (values: AssignPointsFormValues) => Promise<void>;
};

const AssignPointsFormView = ({
  form,
  userTypeOptions,
  userOptions,
  categoryOptions,
  currentCategoryLabel,
  onSubmit,
}: AssignPointsFormViewProps) => (
  <Form form={form} onSubmit={onSubmit}>
    <div className="flex w-full flex-col gap-4.5">
      <Select
        label="pointManagement.page.form.managePoints.userType"
        options={userTypeOptions}
        {...form.register('userType')}
      />
      <Select
        label="common.form.label.userName"
        options={userOptions}
        {...form.register('userName')}
        disabled={!form.watch('userType')}
      />
      <Input
        label="common.form.label.currentCategory"
        maxLength={50}
        value={currentCategoryLabel}
        placeholder="Current Category"
        disabled
        {...form.register('currentCategory')}
      />
      <Select
        label="common.form.label.newCategory"
        options={categoryOptions}
        placeholder="Select Category"
        {...form.register('pointCategoryId')}
        disabled={!form.watch('userType')}
      />
    </div>
  </Form>
);

export default AssignPointsFormView;
